const SignupValidation = (values, rows) => {
  let errors = {};

  // First name validation
  if (values?.firstName?.trim() === "") {
    errors.firstName = "Please enter first name";
  }

  // Last name validation
  if (values?.lastName?.trim() === "") {
    errors.lastName = "Please enter last name";
  }

  // Phone number validation
  if (values?.phone?.trim() === "") {
    errors.phone = "Please enter phone number";
  } else if (!/^\d+$/.test(values.phone)) {
    errors.phone = "Phone number must contain only digits";
  } else if (values.phone.length < 10) {
    errors.phone = "Phone number must be at least 10 digits";
  }

  // Email validation
  if (values?.email?.trim() === "") {
    errors.email = "Please enter email";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = "Please enter a valid email address";
  }

  // Password validation
  if (values?.password?.trim() === "") {
    errors.password = "Please enter password";
  } else if (values?.password?.length < 8) {
    errors.password = "Password must be at least 8 characters";
  }

  // Confirm password validation
  if (values?.confirmPassword?.trim() === "") {
    errors.confirmPassword = "Please enter confirm password";
  } else if (values?.password !== values?.confirmPassword) {
    errors.confirmPassword = "Password does not match";
  }

  return errors;
};

export default SignupValidation;
